import React, { useState } from 'react';
import styles from './finance.scss';
import FinanceSegmented from '../finance/FinanceSegmented/FinanceSegmented';
import CustomDropdown from '../ui/CustomDropdown/CustomDropdown';

const Finance = ({ fields }) => {
  console.log(fields, 'fields');
  const [selectedTab, setSelectedTab] = useState(2); // 默认选择 "Operational Leasing"
  const [selectedLeasing, setSelectedLeasing] = useState(0);
  const [selectedColor, setSelectedColor] = useState(0);

  const tabList = [
    { index: 0, title: 'Private' },
    { index: 1, title: 'Business' },
    { index: 2, title: 'Operational Leasing' },
  ];

  const leasingOptions = [
    {
      title: 'Full Service Leasing',
      price: '€595.98',
      period: 'per month (all-inclusive)',
      description:
        'Complete mobility solution including maintenance, insurance, road tax, and breakdown cover. One fixed monthly payment.',
    },
    {
      title: 'Fleet Management',
      price: '€551.83',
      period: 'per month per vehicle',
      description:
        'Comprehensive fleet solution with vehicle management, maintenance scheduling, and reporting. Ideal for companies with multiple vehicles.',
    },
    {
      title: 'Salary Sacrifice Scheme',
      price: '€331.10',
      period: 'per month (tax-free)',
      description:
        'Employee benefit scheme offering significant tax and National Insurance savings. Available through participating employers.',
    },
  ];

  const colorOptions = [
    { name: 'Carbon Crystal Black', color: '#2C2C2C' },
    { name: 'White', color: '#FFFFFF' },
    { name: 'Black', color: '#000000' },
    { name: 'Blue', color: '#1E3A8A' },
    { name: 'Grey', color: '#6B7280' },
  ];

  const handleTabSelect = (tabIndex) => {
    setSelectedTab(tabIndex);
  };
  return (
    <div className="finance container">
      {/* Header */}
      <div className="header">
        <div className="backButton">← Back to Configuration</div>
      </div>

      {/* Main Content */}
      <div className={'mainContent'}>
        {/* Left Column - Leasing Options */}
        <div className="leftColumn">
          <div className="tabContainer">
            <FinanceSegmented items={tabList} activeIndex={selectedTab} onClick={handleTabSelect} />
          </div>

          {/* 根据selectedTab显示不同的section */}
          {selectedTab === 0 && (
            <div className="first-section">
              <div className="section active">
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Personal Finance</span>
                    </label>
                  </div>
                </div>
                <div className="money">€1003.33</div>
                <div className={'date'}>per month</div>
                <div className={'price-desc'}>
                  for 30 months with €1200.00 cash down. Incl. fees, and a balloon payment of
                  €1200.00 at the end of the term.
                </div>
                <div className={'field'}>
                  <label className={'field_label'}>Term</label>
                  <div className={'field_dropdown'}>
                    <CustomDropdown
                      options={colorOptions}
                      placeholderValue={<span className={'field_dropdown_placeholder'}>Term</span>}
                      isOptionsAbsolutePosition
                      onSelect={(option) => {
                        console.log(option);
                      }}
                    />
                  </div>
                </div>
                <div className={'field'}>
                  <label className={'field_label'}>Down Payment</label>
                  <input className={'field_input'} type="text" onChange={(e) => {}} />
                  <div className={'tips'}>Down Payment must be between €0.00 and €32,500.00.</div>
                </div>
                <div className={'field'}>
                  <label className={'field_label'}>Balloon Payment</label>
                  <input className={'field_input'} type="text" onChange={(e) => {}} />
                  <div className={'tips'}>
                    Finance estimate from OMODA & JAECOO Financial Services
                  </div>
                </div>
              </div>
            </div>
          )}

          {selectedTab === 1 && (
            <div className="second-section">
              <div className={'section active'}>
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Business Finance</span>
                    </label>
                  </div>
                </div>
                <div className="money">€895.50</div>
                <div className={'date'}>per month</div>
                <div className={'price-desc'}>
                  for 36 months with €1500.00 cash down. Incl. fees, and a balloon payment of
                  €1500.00 at the end of the term.
                </div>
              </div>
              <div className={'section'}>
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Business Lease</span>
                    </label>
                  </div>
                </div>
                <div className="money">€745.25</div>
                <div className={'date'}>per month</div>
                <div className={'price-desc'}>
                  for 48 months with €2000.00 cash down. Incl. fees, and a balloon payment of
                  €2000.00 at the end of the term.
                </div>
              </div>
              <div className={'section'}>
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Hire Purchase</span>
                    </label>
                  </div>
                </div>
                <div className="money">€825.75</div>
                <div className={'date'}>per month</div>
                <div className={'price-desc'}>
                  for 42 months with €1000.00 cash down. Incl. fees, and a balloon payment of
                  €1000.00 at the end of the term.
                </div>
              </div>
            </div>
          )}

          {selectedTab === 2 && (
            <div className="third-section">
              <div className={'section active'}>
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Full Service Leasing</span>
                    </label>
                  </div>
                </div>
                <div className="money">€595.98</div>
                <div className={'date'}>per month (all-inclusive)</div>
                <div className={'price-desc'}>
                  Complete mobility solution including maintenance, insurance, road tax, and
                  breakdown cover. One fixed monthly payment.
                </div>
              </div>
              <div className={'section'}>
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Fleet Management</span>
                    </label>
                  </div>
                </div>
                <div className="money">€551.83</div>
                <div className={'date'}>per month per vehicle</div>
                <div className={'price-desc'}>
                  Comprehensive fleet solution with vehicle management, maintenance scheduling, and
                  reporting. Ideal for companies with multiple vehicles.
                </div>
              </div>
              <div className={'section'}>
                <div className={'title '}>
                  <div className={'checkboxContainer'}>
                    <label className={'checkboxLabel'}>
                      <input type="radio" className={'checkboxInput'} onChange={(e) => {}} />
                      <span className={'customCheckbox'}></span>
                      <span className={'checkboxLabel_text'}>Salary Sacrifice Scheme</span>
                    </label>
                  </div>
                </div>
                <div className="money">€331.10</div>
                <div className={'date'}>per month (tax-free)</div>
                <div className={'price-desc'}>
                  Employee benefit scheme offering significant tax and National Insurance savings.
                  Available through participating employers.
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Right Column - Vehicle Details & Finance Summary */}
        <div className={'rightColumn'}>
          <div className={'section car-section'}>
            <img
              src="https://6d8772eb-5ec6-4a39-92e5-821b71be1520-figmaiframepreview.figma.site/aac6689b-1a26-4bfb-9d3a-f3d8e7dde935#filename=2b3dec49b2a34fa844f917c56568305db230be9b.png"
              alt="OMODA 5 EV"
              className={'color-img'}
            />
            <div className={'car-title'}>OMODA 5 EV</div>
            <div className={'flex-row mt12'}>
              <div className={'label'}>OMODA Clifton Park</div>
            </div>
            <div className={'flex-row'}>
              <div className={'label'}>Mechanicville, NY, 12118</div>
            </div>
          </div>
          <div className={'section price-section'}>
            <div className={'title '}>Price details</div>
            <div className={'flex-row'}>
              <div className={'label'}>Model Base Price</div>
              <div className={'value'}>€1003.33</div>
            </div>
            <div className={'flex-row font-weight600'}>
              <div className={'label'}>Total Retail Price</div>
              <div className={'value'}>€1003.33</div>
            </div>
          </div>

          <div className={'section finance-summary-section'}>
            <div className={'title '}>Finance Summary</div>
            <div className={'flex-row'}>
              <div className={'label'}>Annual Percentage Rat</div>
              <div className={'value'}>7.24%</div>
            </div>
            <div className={'flex-row '}>
              <div className={'label'}>Term</div>
              <div className={'value'}>30 months</div>
            </div>
            <div className={'flex-row '}>
              <div className={'label'}>Down Payment</div>
              <div className={'value'}>€1200.00</div>
            </div>
            <div className={'flex-row'}>
              <div className={'label'}>Finance Type</div>
              <div className={'value'}>business lease</div>
            </div>
            <div className={'line'}>
              <div className={'label'}>Est. monthly payment</div>
              <div className={'total'}>€375.25</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Finance;
